<template>
    <layout :menu="menu">
      <template v-slot:toolbar-left>
        <company-toolbar-branding />
      </template>

      <template v-slot:toolbar-right>
        <deposito-display v-if="isAuth"/>
        <v-btn v-if="canManageUserConfiguration" icon :to="{ name: 'UserConfigurationManagementPage' }" class="mr-2 toolbar-icon-btn">
          <v-icon color="white">mdi-cog</v-icon>
        </v-btn>
        <app-bar-user-menu class="toolbar-icon-btn"/>
      </template>


      <router-view></router-view>
    </layout>
</template>

<script>
import Layout from "./layout/Layout";
import menuConfig from './menu-config'
import {AppBarUserMenu} from '@dracul/user-frontend'
import {mapGetters} from "vuex";
import DepositoDisplay from './layout/components/DepositoDisplay'
import CompanyToolbarBranding from './layout/components/CompanyToolbarBranding'
import UserConfigurationProvider from './modules/user-configuration/providers/UserConfigurationProvider'
import CompanyProvider from './modules/base/providers/CompanyProvider'
import CompanyPdfLogoProvider from './modules/user-configuration/providers/CompanyPdfLogoProvider'

export default {
  name: 'App',
  components: {Layout, AppBarUserMenu, CompanyToolbarBranding, DepositoDisplay},
  async mounted() {
    await this.$store.dispatch('checkAuth')
    
    // Cargar configuración del usuario en el cache si está autenticado
    // Solo cargar si no está ya en el cache
    if (this.$store.getters.isAuth) {
      // Sync effective permissions (applies UserPermission overrides to hasPermission)
      await this.$store.dispatch('fetchEffectivePermissions').catch(() => {})

      try {
        const depositoId = UserConfigurationProvider.getDepositoIdFromCache();
        if (depositoId === null) {
          // Si no hay datos en el cache, cargar la configuración
          await UserConfigurationProvider.getUserConfiguration(false);
        }
      } catch (error) {
        // Si hay error al leer el cache, intentar cargar desde el servidor
        try {
          await UserConfigurationProvider.getUserConfiguration(true);
        } catch (err) {
          console.error('Error loading user configuration:', err);
        }
      }

      // Cargar companyId si no está en el store
      if (!this.$store.state.user.companyId) {
        try {
          const response = await CompanyProvider.getMyCompanyId();
          if (response.data.me?.companyId) {
            // Guardar directamente en el state (se persistirá automáticamente)
            this.$store.state.user.companyId = response.data.me.companyId;
          }
        } catch (error) {
          console.error('Error loading companyId:', error);
        }
      }

      this.loadCompanyPdfLogoForHeader()
    }
  },
  watch: {
    isAuth(val) {
      if (val) {
        this.$store.dispatch('fetchEffectivePermissions').catch(() => {})
        this.loadCompanyPdfLogoForHeader()
      } else {
        this.$store.commit('companyBranding/reset')
      }
    },
  },
  methods: {
    loadCompanyPdfLogoForHeader() {
      if (!this.$store.getters.isAuth) return
      CompanyPdfLogoProvider.get()
        .then((response) => {
          const payload = response && response.data && response.data.companyPdfLogoGet
          this.$store.commit(
            'companyBranding/setPdfLogoFromPayload',
            payload || { hasLogo: false }
          )
        })
        .catch(() => {
          this.$store.commit('companyBranding/setPdfLogoFromPayload', { hasLogo: false })
        })
    },
  },
  computed: {
    ...mapGetters(['me', 'isAuth']),
    getUserId() {
      return this.me ? this.me.id : null
    },
    menu() {
      return this.isAuth ? menuConfig : []
    },
    canManageUserConfiguration() {
      const perms = this.me && this.me.role && this.me.role.permissions
      return !!(perms && perms.includes('USER_CONFIGURATION_SHOW'))
    },
  }
};
</script>

<style scoped>
.toolbar-icon-btn ::v-deep .v-icon {
  color: white !important;
}

.toolbar-icon-btn ::v-deep button {
  color: white !important;
}

.toolbar-icon-btn ::v-deep a {
  color: white !important;
}

.toolbar-icon-btn ::v-deep .v-btn {
  color: white !important;
}

.toolbar-icon-btn ::v-deep .v-btn__content {
  color: white !important;
}
</style>

<style>
/* Estilos globales para los iconos del toolbar */
.v-toolbar .v-btn--icon .v-icon,
.v-toolbar .v-btn .v-icon,
.v-toolbar a .v-icon {
  color: white !important;
}

.v-toolbar .v-btn--icon,
.v-toolbar .v-btn--text,
.v-toolbar a.v-btn {
  color: white !important;
}
</style>
